import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { isEmpty, uniqueId } from 'lodash';
import filesize from "filesize";
import axios from "axios";
import { i18n } from '../../../translate/i18n';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  Paper,
  Typography,
  FormControl,
  IconButton,
  Container,
  TextField,
  Button,
  useMediaQuery,
  Tooltip,
  InputAdornment,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import LinkIcon from '@mui/icons-material/Link';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBack from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachIcon from '@mui/icons-material/AttachFile';
import Accordion from '@mui/material/Accordion';
import API from '../../../axios/api';
import * as actions from "../../../store/actions";

import {
  FormStyled,
  DoneIconStyled,
  DivSubmitButtons,
  DivFormTitle,
  FormStatus,
  FormStatusLabel,
  FormStatusValue,
  ExpandPainelContainer,
  ExpandPainelItemContainer,
  ExpandPainelItemLabel,
  ButtonGroup
} from '../../Actions/styles';

import confirm from '../../../UI/Confirm/confirm';
import Spinner from '../../../components/Spinner/index';
import Upload from '../../../UI/Upload';
import FileList from '../../../UI/FileList';
import resizeFile from '../../../utils/imageResizer';
import { map as asyncMap } from 'p-iteration';
import { toastr } from 'react-redux-toastr';
import CompleteActionModal from '../../../components/CompleteActionModal/CompleteActionModal';
import TimelineMaintenances from '../../Maintenances/TimelineMaintenances/index.js';
import FormLabelWithContent from '../../../UI/FormLabelWithContent';
import statusLabelMaintenance from '../../../utils/statusLabelMaintenance';
import numberToCurrency from '../../../utils/numberToCurrency';
import { EAccessRole } from '../../../store/types';

const styles = {
  arrowBack: {
    position: 'fixed',
    marginTop: 10,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 50,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: 'relative'
  },
  paper: {
    borderRadius: 7,
  },
  formTitle: {
    fontWeight: 600,
    paddingLeft: 5,
    paddingBottom: 10,
  },
  expandPanelStyle: {
    backgroundColor: '#eee',
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  opacityContainer: {
  },
  uploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    height: '140px',
  },
  infoContainer: {
    marginTop: 10,
    position: 'relative',
  },
  infoContainer2: {
    paddingTop: 10,
    paddingLeft: 20,
  },
  detailsContainer: {
    padding: '0px 20px 20px 20px',
  },
  label: {
    fontSize: 13,
  },
  labelEquipDetail: {
    marginLeft: 10
  },
  sectionTitleContainer: {
    display: 'flex',
    marginTop: 20,
  },
  serviceLabel: {
    display: 'flex',
    alignItems: 'center',
    // cursor: 'pointer'
  },
  expandIcon: {
    '.MuiSvgIcon-root': {
      transform: 'rotate(180deg)'
    }
  },
  doneActionButton: {
    margin: 10,
    height: 40,
    backgroundColor: 'green',
  },
  cancelActionButton: {
    margin: 10,
    height: 40,
    backgroundColor: '#585858'
  },
  reopenActionButton: {
    margin: 10,
    height: 40,
    backgroundColor: '#0363c3',
  },
  maintenanceLabel: {
    fontSize: '12px',
  },
  maintenanceLabelPadding: {
    marginTop: '10px',
    marginBottom: '3px'
  },
  maintenanceInfo: {color: 'black'},
}

const FormHandleMaintenance = (props) => {
  const dispatch = useDispatch();
  const matches = useMediaQuery('(min-width:1200px)');

  const equipmentId = props.match.params.equip_id;
  const maintenanceId = props.match.params.id !== 'new' ? props.match.params.id : '';

  const [editMode, setEditMode] = useState(false);
  const [isNewData, setIsNewData] = useState(true);
  const [completeModalIsOpen, setCompleteModalIsOpen] = useState(false);

  // maintenance fields
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [identifier, setIdentifier] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState('')
  const [sendToMaintenanceDate, setSendToMaintenanceDate] = useState(new Date());
  const [returnFromMaintenanceDate, setReturnFromMaintenanceDate] = useState(new Date());
  const [warrantyPeriod, setWarrantyPeriod] = useState(null)
  const [expirationDate, setExpirationDate] = useState(null);
  const [company, setCompany] = useState("");
  const [status, setStatus] = useState("scheduled")
  const [isPending, setIsPending] = useState(false)
  const [isOverdue, setIsOverdue] = useState(false)

  const [filesAdded, setfilesAdded] = useState([]);
  const [filesDeleted, setFilesDeleted] = useState([]);

  // error forms
  const [sendToMaintenanceDateError, setSendToMaintenanceDateError] = useState(false);
  const [warrantyPeriodError, setWarrantyPeriodError] = useState(false)
  const [expirationDateError, setExpirationDateError] = useState(false)

  const [uploadSubmitError, setUploadSubmitError] = useState(false)

  // fetch Equipment from BE
  const fetchEquipmentById = useCallback(
    () => dispatch(actions.fetchEquipmentsById(equipmentId)),
    [dispatch, equipmentId],
  );
  
  const fetchMaintenanceById = useCallback(
    () => dispatch(actions.fetchMaintenanceById(maintenanceId))
  );
    
  // get from redux
  const selectedAccess = useSelector(state => state.auth.selectedAccess);
  const role = useSelector(state => state.auth.selectedAccess.role);
  const equipment = useSelector(state => state.equipments.equipment);
  const maintenance = useSelector(state => state.maintenances.maintenance);
  const isAnalyst = role === EAccessRole.analyst;
  const isContractor = role === EAccessRole.contractor;
  const isInspector = selectedAccess.inspector && (isAnalyst || isContractor);

  const loadingMaintenance = useSelector(state => state.maintenances.loading);

  // check if is newEntrance or editing
  useEffect(() => {
    setIsNewData(props.match.params.id === 'new' ? true : false)
    if (props.match.params.id !== 'new') {
      fetchMaintenanceById();
    }
  }, [])

  useEffect(() => {
    if(equipmentId) {
      fetchEquipmentById()
    }
  }, [equipmentId, fetchEquipmentById])

  // in case editing, populate fields
  useEffect(() => {
    if (!isEmpty(maintenance) && !isNewData) {
      setIdentifier(maintenance.identifier)
      setDescription(maintenance.description)
      setAmount(maintenance.value > 0 ? numberToCurrency(maintenance.value) : '')
      setSendToMaintenanceDate(maintenance.sendToMaintenanceDate)
      setReturnFromMaintenanceDate(maintenance.returnFromMaintenanceDate)
      maintenance.warranty && setWarrantyPeriod(maintenance.warranty)
      maintenance.expiration && setExpirationDate(maintenance.expiration)
      setCompany(maintenance.company)
      setUploadedFiles(maintenance.files)
      setStatus(maintenance.status)
    }
  }, [isNewData, maintenance])

  // send data to Server (post and update)
  const postMaintenance = (body) => dispatch(actions.postMaintenance(body))
  const updateMaintenance = (body) => dispatch(actions.updateMaintenance(maintenanceId, body))
  const deleteMaintenance = () => dispatch(actions.deleteMaintenance(maintenanceId));

  const onlyNumbers = value => {
    return value.replace(/\D/g, '');
  };

  const currencyToNumber = text => {
    return Number(
      text
        .toString()
        .replace('R$ ', '')
        .replace(/\./g, '')
        .replace(',', ''),
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    const notUploaded = uploadedFiles.filter(fl => fl.uploaded === false)
    if (notUploaded.length > 0) {
      setUploadSubmitError(true)
      hasError = true;
    }

    const filesIds = []

    uploadedFiles.map(fl => {
      if (fl.id)
        return filesIds.push(fl.id)
      else if (fl._id)
        return filesIds.push(fl._id)
    });

    if (hasError) return;

    // handle Date range errors. If has an error user cannot submit the maintenance.
    if(sendToMaintenanceDateError) return;
    if(warrantyPeriodError) return;
    if(expirationDateError) return;

    const body = {
      equipment: equipmentId,
      identifier,
      description,
      value: currencyToNumber(amount),
      sendToMaintenanceDate,
      returnFromMaintenanceDate,
      warranty: warrantyPeriod,
      expiration: expirationDate,
      company,
      status,
      files: filesIds,
      site: equipment.site
    }

    if (isNewData) {
      postMaintenance(body).then(result => {
        if (result === 'success') {
          props.history.goBack()
        }
      })
    } else {
      if(filesAdded.length > 0) body.filesAdded = filesAdded;
      if(filesDeleted.length > 0) body.filesDeleted = filesDeleted;
      updateMaintenance(body).then(result => {
        setEditMode(false)
        setFilesDeleted([])
      })
    }
  }

  const handleSaveNewStatus = (status, files = []) => {
    let hasError = false;

    const notUploaded = uploadedFiles.filter(fl => fl.uploaded === false)
    if (notUploaded.length > 0) {
      setUploadSubmitError(true)
      hasError = true;
    }

    const filesIds = []

    uploadedFiles.map(fl => {
      if (fl.id)
        return filesIds.push(fl.id)
      else if (fl._id)
        return filesIds.push(fl._id)
    });

    if (hasError) return

    const body = {
      equipment: equipmentId,
      identifier,
      description,
      value: currencyToNumber(amount),
      sendToMaintenanceDate,
      returnFromMaintenanceDate,
      warranty: warrantyPeriod,
      expiration: expirationDate,
      company,
      status,
      files: filesIds,
    }

    if (isNewData) {
      postMaintenance(body).then(result => {
        if (result === 'success') {
          props.history.goBack()
        }
      })
    } else {
      updateMaintenance(body).then(result => {
        if (result === 'success') {
          setStatus(status)
          setEditMode(false)
        }
      })
    }
  };

  const handleBack = () => {
    props.history.goBack()
  }

  const handleSetSendToMaintenanceDateChange = date => {
    setSendToMaintenanceDate(date);
  }

  const handleReturnFromMaintenanceDateChange = date => {
    setReturnFromMaintenanceDate(date);
  }

  const handleWarrantyPeriodChange = date => {
    setWarrantyPeriod(date);
  }

  const handleExpirationDateChange = date => {
    setExpirationDate(date);
  }

  const handleUpload = async files => {
    const canUploadFiles = true /* checkUploadPermissions() */;
    if (canUploadFiles) {
    const uploadingFiles = await asyncMap(files, async (file) => {
      const fileOptimized = await resizeFile(file)

      return ({
        file: fileOptimized,
        id: uniqueId(),
        name: fileOptimized.name,
        readableSize: filesize(fileOptimized.size),
        preview: URL.createObjectURL(fileOptimized),
        fileType: fileOptimized.type,
        progress: 0,
        isNotUploaded: true,
        error: false,
        url: null
      });
    });

    setUploadedFiles(prevUf => prevUf.concat(uploadingFiles))
    uploadingFiles.forEach(processUpload);
  } else {
    toastr.error('Erro', i18n.t('updateActionsStore.toastrError2'))
  }
  };

  const updateFile = (id, data) => {
    setUploadedFiles(prevUf => prevUf.map(uf => id === uf.id ? { ...uf, ...data } : uf))
  };


  const processUpload = async uploadedFile => {

    API.post("files/signurl", { file: uploadedFile }).then(signUrlRes => {

      axios.put(signUrlRes.data.url, uploadedFile.file, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile.id, {
            progress
          });
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `files/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType,
          source: 'web',
        }

        API.post("files", body)
          .then(response => {
            setUploadSubmitError(false)
            updateFile(uploadedFile.id, {
              isNotUploaded: false,
              id: response.data._id,
              url: response.data.url,
              error: false,
              loading: false,
            });
          })
          .catch(() => {
            updateFile(uploadedFile._id, {
              error: true,
              loading: false,
            });
          });
      })
    })
  }

  const checkPermission = (id) => {
    const file = uploadedFiles.find(fl => fl.id === id)
    if (role === 'contractor') {
      if (typeof file.uploaded !== 'undefined' /* && (actionService.accountable._id === userId || actionService.createdBy?._id === userId) */) {
        handleDeleteFile(id, true);
      } else {
        toastr.error('Erro', i18n.t('updateActionsStore.toastrError2'));
      }
    } else {
      handleDeleteFile(id, false);
    }
  }

  // const checkUploadPermissions = () => {
  //   if (role === 'contractor') {
  //     if (actionService.accountable._id === userId || actionService.createdBy?._id === userId) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return true;
  //   }
  // }

  const handleDeleteFile = async (id, isContractor) => {
    try {
      if (!isContractor) await API.delete(`files/${id}`)
      setFilesDeleted([...filesDeleted, uploadedFiles.find(file => file.id === id)])
      setUploadedFiles(prevUf => prevUf.filter(file => file.id !== id && file._id !== id))

    } catch (e) {
      console.log('e', e);
    }
  }

  const handleDeleteDocumentFile = (id) => {
    if (!editMode && !isNewData && !completeModalIsOpen) return;
    confirm(i18n.t('handleDeleteDocumentFileFormActions.confirm'),
      {
        title: i18n.t('handleDeleteDocumentFileFormActions.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          console.log('check permission')
          checkPermission(id)
        },
      )
  }

  const handleMaintenanceStatus = (value, handleAction) => {
    confirm(`${i18n.t('handleMaintenanceStatusModal.text1')} ${handleAction} ${i18n.t('handleMaintenanceStatusModal.text2')}`,
      {
        title: `${handleAction} ${i18n.t('handleMaintenanceStatusModal.confirm_title')}`,
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          setIsPending(false)
          setIsOverdue(false)
          handleSaveNewStatus(value);
        },
      );
  };

  const handleCloseCompleteModal = () => {
    setCompleteModalIsOpen(false);
  }

  const handleCompleteAction = (files) => {
    const newStatus = { label: i18n.t('handleCompleteActionFormActions.newStatus'), value: 'completed' };
    handleSaveNewStatus(newStatus, files);
  };
  
  const handleDelete = () => {
    confirm(i18n.t('handleDeleteMaintenanceModal.text1'),
      {
        title: i18n.t('handleDeleteMaintenanceModal.text2'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          deleteMaintenance().then(() => {
            setEditMode(false);
            props.history.push(`/form-equip/${equipmentId}/admin-gestao-equip`);
          });
        },
      );
  };

  const goToEquipment = (id) => {
    props.history.push(`/form-equip/${id}/admin-gestao-equip`);
  };

  const handleClose = () => {
    setEditMode(false);    
    setIdentifier(maintenance.identifier)
    setDescription(maintenance.description)
    setAmount(maintenance.value > 0 ? numberToCurrency(maintenance.value) : '')
    setSendToMaintenanceDate(maintenance.sendToMaintenanceDate)
    setReturnFromMaintenanceDate(maintenance.returnFromMaintenanceDate)
    maintenance.warranty && setWarrantyPeriod(maintenance.warranty)
    maintenance.expiration && setExpirationDate(maintenance.expiration)
    setCompany(maintenance.company)
    setUploadedFiles(maintenance.files)
    setFilesDeleted([])
    setStatus(maintenance.status)
  };

  const handleCurrency = value => {
    const string = onlyNumbers(value)
    setAmount(string);
  }

  const handleStatusTranslation = status => {
    if(isPending && status === 'scheduled') return i18n.t('maintenancesStatusLabel.title4'); // Pendente
    if(isOverdue) return i18n.t('maintenancesStatusLabel.title6'); // Em Atraso
    if (status === 'completed' && expirationDate !== null && new Date() > moment(new Date(expirationDate)).endOf('day').toDate()) return i18n.t('maintenancesStatusLabel.title5'); // Vencida

    switch (status) {
      case 'progress':
        return i18n.t('maintenancesStatusLabel.title'); // Em Progresso
      case 'scheduled':
        return i18n.t('maintenancesStatusLabel.title3'); // Agendada
      case 'canceled':
        return i18n.t('maintenancesStatusLabel.title1'); // Cancelada
      case 'completed':
        return i18n.t('maintenancesStatusLabel.title2'); // Concluída
      default:
        break;
    }
  }

  useEffect(() => {
    setfilesAdded(uploadedFiles.filter(item => !item.createdAt))
  }, [uploadedFiles])

  useEffect(() => {
    if(new Date() < moment(new Date(sendToMaintenanceDate)).endOf('day').toDate()) {
      setIsPending(false)
    } else if(new Date() > moment(new Date(sendToMaintenanceDate)).endOf('day').toDate()) {
      setIsPending(true)
    }
  }, [sendToMaintenanceDate])

  useEffect(() => {
    if(status === 'progress' && new Date() > moment(new Date(returnFromMaintenanceDate)).endOf('day').toDate()) {
      setIsOverdue(true)
    } else {
      setIsOverdue(false)
    }
  }, [returnFromMaintenanceDate, status])

  return <>
    {completeModalIsOpen && (
      <CompleteActionModal
        closeModal={handleCloseCompleteModal}
        handleUpload={handleUpload}
        handleDeleteFile={handleDeleteDocumentFile}
        uploadedFiles={uploadedFiles}
        handleCompleteAction={handleCompleteAction}
      />
    )}

    <IconButton onClick={handleBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>
    <div style={matches ? styles.divContainer : styles.divContainerSmall}>
      <Container maxWidth='md' style={styles.container}>
        
        {loadingMaintenance && <Spinner overlay />}
        <Typography variant='h6' style={styles.formTitle}>{isNewData ? i18n.t('formMaintenance.formTitleCreate') : i18n.t('formMaintenance.formTitleEdit')}</Typography>
        
        <ButtonGroup>
          {!isNewData && status !== 'canceled' &&
            <Button disabled={isInspector} variant="contained" onClick={() => handleMaintenanceStatus('canceled', i18n.t('handleMaintenanceStatusModal.cancel'))} color="secondary" style={styles.cancelActionButton}>
              {i18n.t('buttonFormMaintenance.cancel')}
                </Button>}
          {!isNewData && status !== 'progress' && status !== 'completed' &&
            <Button disabled={isInspector} variant="contained" onClick={() => handleMaintenanceStatus('progress', i18n.t('handleMaintenanceStatusModal.send'))} color="primary" style={styles.reopenActionButton}>
              {i18n.t('buttonFormMaintenance.send_to_maintenance')}
                </Button>} 
          {!isNewData && status !== 'completed' && status !== 'scheduled' && status !== 'canceled' &&
            <Button disabled={isInspector} variant="contained" onClick={() => handleMaintenanceStatus('completed', i18n.t('handleMaintenanceStatusModal.complete'))} color="primary" style={styles.doneActionButton}>
              {i18n.t('buttonFormMaintenance.done')}
                </Button>}
          {!isNewData && status === 'completed' &&
            <Button disabled={isInspector} variant="contained" onClick={() => handleMaintenanceStatus('progress', i18n.t('handleMaintenanceStatusModal.reactivate'))} color="primary" style={styles.reopenActionButton}>
              {i18n.t('buttonFormMaintenance.send_back_to_maintenance')}
                </Button>}
        </ButtonGroup>
        
        <Paper style={styles.paper}>
          <FormStyled onSubmit={handleSubmit} style={{ opacity: loadingMaintenance ? '0.3' : '1' }}>
            {!isNewData && <DivFormTitle>

              {!isNewData && 
              <FormStatus style={{ borderColor: statusLabelMaintenance(status, maintenance).color }}>
                <FormStatusLabel>{'Status'}</FormStatusLabel>
                <FormStatusValue>{handleStatusTranslation(status)}</FormStatusValue>
              </FormStatus>}

              {!isNewData &&
                <DivSubmitButtons>
                  {editMode ?
                    <>
                      <IconButton onClick={() => handleClose()} size="large"><CloseIcon color='error' /></IconButton>
                      <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                    </> :
                    <>
                      <IconButton disabled={isInspector} onClick={() => setEditMode(true)} size="large">
                        <Tooltip title={i18n.t('tooltipFormActions.edit')}><EditIcon /></Tooltip>
                      </IconButton>
                      <IconButton disabled={isInspector} onClick={() => handleDelete()} size="large">
                        <Tooltip title={i18n.t('tooltipFormActions.delete')}><DeleteIcon /></Tooltip>
                      </IconButton>
                    </>}
                </DivSubmitButtons>}
            </DivFormTitle>}
            <>
              <div style={styles.infoContainer}>
                <ExpandPainelContainer>
                  <Accordion expanded={false} styles={styles.expandPanelStyle}>
                    <div
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      style={styles.infoContainer2}
                    >
                      <ExpandPainelItemContainer>
                        <ExpandPainelItemLabel>
                          {i18n.t('expandPainelItemLabelformActions.local')}
                        </ExpandPainelItemLabel>
                        {equipment?.place?.name ? equipment?.place?.name : '-'}
                      </ExpandPainelItemContainer>
                      <ExpandPainelItemContainer>
                        <ExpandPainelItemLabel>
                        {i18n.t('expandPainelItemLabelformActions.equipment')}
                           {(equipmentId) &&
                            <IconButton
                              style={{ marginLeft: 5, cursor: 'pointer', background: '#cdd8ea', padding: '0px 2px 0px 2px', borderRadius: 3 }}
                              onClick={() => goToEquipment(equipmentId)}
                              size="large">
                              <Tooltip title={i18n.t('tooltipFormActions.equipment')}>
                                <LinkIcon color='primary' />
                              </Tooltip>
                            </IconButton>}
                        </ExpandPainelItemLabel>
                        {equipment?.equipmentModel?.name ? equipment?.equipmentModel?.name : '-'}

                        <ExpandPainelItemLabel>
                          {i18n.t('expandPainelItemLabelformActions.sn')}
                          </ExpandPainelItemLabel>
                          {equipment?.serialNumber || i18n.t('expandPainelItemLabelformActions.text')}
                        </ExpandPainelItemContainer>
                        <ExpandPainelItemContainer>
                          <ExpandPainelItemLabel>
                          {i18n.t('expandPainelItemLabelformActions.description')}
                          </ExpandPainelItemLabel>
                          {equipment?.description ? equipment?.description : '-'}
                        </ExpandPainelItemContainer>
                        <ExpandPainelItemContainer>
                          <ExpandPainelItemLabel>
                            {i18n.t('expandPainelItemLabelformActions.equipmentReference')}
                              </ExpandPainelItemLabel>
                          {equipment?.reference ? equipment?.reference : '-'}
                      </ExpandPainelItemContainer>
                    </div>
                  </Accordion>
                </ExpandPainelContainer>
              </div>

              <div style={styles.detailsContainer}>
                {(editMode || isNewData) ?
                  <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    multiline
                    InputProps={{
                      readOnly: !isNewData && !editMode,
                    }}
                    label={i18n.t('formMaintenance.identifier')}
                    name='identifier'
                    onChange={event => setIdentifier(event.target.value.toUpperCase())}
                    value={identifier}
                    disabled={editMode && isContractor}
                    margin='normal' />
                </FormControl>
                :
                <FormLabelWithContent label={i18n.t('formMaintenance.identifier')} value={identifier ? identifier : '-'} maintenance={true} />}

                {(editMode || isNewData) ?
                  <FormControl variant="standard" fullWidth>
                  <TextField
                    variant="standard"
                    multiline
                    InputProps={{
                      readOnly: !isNewData && !editMode,
                    }}
                    label={i18n.t('formMaintenance.description')}
                    name='description'
                    onChange={event => setDescription(event.target.value.toUpperCase())}
                    value={description}
                    disabled={editMode && isContractor}
                    margin='normal' />
                </FormControl>
                :
                <FormLabelWithContent label={i18n.t('formMaintenance.description')} value={description ? description : '-'} maintenance={true} />}

                {(editMode || isNewData) ?
                <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  InputProps={{
                    readOnly: !isNewData && !editMode,
                    startAdornment: <InputAdornment position="start">R$</InputAdornment>
                  }}
                  label={i18n.t('formMaintenance.value')}
                  name='amount'
                  onChange={event => handleCurrency(event.target.value)}
                  value={numberToCurrency(amount)}
                  type="text"
                  disabled={editMode && isContractor}
                  margin='normal' />
              </FormControl>
                :
                <FormLabelWithContent label={i18n.t('formMaintenance.value')} value={onlyNumbers(amount) > 0 ? 'R$ ' + numberToCurrency(amount) : '-'} maintenance={true} />}

                {(editMode || isNewData) ?
                <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  multiline
                  InputProps={{
                    readOnly: !isNewData && !editMode,
                  }}
                  label={i18n.t('formMaintenance.company')}
                  name='company'
                  onChange={event => setCompany(event.target.value.toUpperCase())}
                  value={company}
                  disabled={editMode && isContractor}
                  margin='normal' />
              </FormControl>
              :
              <FormLabelWithContent label={i18n.t('formMaintenance.company')} value={company ? company : '-'} maintenance={true} />}

                {(editMode || isNewData) ?
                <div>
                <DatePicker
                  required
                  label={i18n.t('formMaintenance.sendToMaintenanceDate')}
                  margin='normal'
                  value={new Date(sendToMaintenanceDate)}
                  InputProps={{
                    readOnly: !isNewData && !editMode,
                  }}
                  onChange={date => {
                    if((editMode && !isNewData) || (!editMode && isNewData)) handleSetSendToMaintenanceDateChange(date)
                  }}
                  format="dd/MM/yyyy"
                  disabled={editMode && isContractor}
                  sx={{marginTop: '10px'}}
                  slotProps={{ textField: { variant: 'standard', } }}
                />
              </div>
              :
              <FormLabelWithContent label={i18n.t('formMaintenance.sendToMaintenanceDate')} value={sendToMaintenanceDate === null ? '' : moment(sendToMaintenanceDate).format('DD/MM/YYYY')} maintenance={true} />}

                {(editMode || isNewData) ?
                <div>
                <DatePicker
                  required
                  label={i18n.t('formMaintenance.returnFromMaintenanceDate')}
                  margin='normal'
                  value={new Date(returnFromMaintenanceDate)}
                  InputProps={{
                    readOnly: !isNewData && !editMode,
                  }}
                  onChange={date => {
                    if((editMode && !isNewData) || (!editMode && isNewData)) handleReturnFromMaintenanceDateChange(date)
                  }}
                  minDate={new Date(sendToMaintenanceDate)}
                  minDateMessage={i18n.t('handleDatePickerErrorMessage.sendToMaintenanceDateError')}
                  onError={(err, value) => {
                    err?.toString() === i18n.t('handleDatePickerErrorMessage.sendToMaintenanceDateError') ? setSendToMaintenanceDateError(true) : setSendToMaintenanceDateError(false)
                  }}
                  format="dd/MM/yyyy"
                  disabled={editMode && isContractor}
                  sx={{marginTop: '10px'}}
                  slotProps={{ textField: { variant: 'standard', } }}
                />
              </div>
              :
              <FormLabelWithContent label={i18n.t('formMaintenance.returnFromMaintenanceDate')} value={returnFromMaintenanceDate === null ? '' : moment(returnFromMaintenanceDate).format('DD/MM/YYYY')} maintenance={true} />}

                {(editMode || isNewData) ?
                <div>
                <DatePicker
                  label={i18n.t('formMaintenance.warranty')}
                  margin='normal'
                  value={warrantyPeriod && new Date(warrantyPeriod)}
                  InputProps={{
                    readOnly: !isNewData && !editMode,
                  }}
                  onChange={date => {
                    if((editMode && !isNewData) || (!editMode && isNewData)) handleWarrantyPeriodChange(date)
                  }}
                  minDate={new Date(returnFromMaintenanceDate)}
                  minDateMessage={i18n.t('handleDatePickerErrorMessage.returnFromMaintenanceDateError')}
                  onError={(err, value) => {
                    err?.toString() === i18n.t('handleDatePickerErrorMessage.returnFromMaintenanceDateError') ? setWarrantyPeriodError(true) : setWarrantyPeriodError(false)
                  }}
                  format="dd/MM/yyyy"
                  disabled={editMode && isContractor}
                  sx={{marginTop: '10px'}}
                  slotProps={{ textField: { variant: 'standard', } }}
                />                    
              </div>
              :
              <FormLabelWithContent label={i18n.t('formMaintenance.warranty')} value={warrantyPeriod === null ? '-' : moment(warrantyPeriod).format('DD/MM/YYYY')} maintenance={true} />}

              {(editMode || isNewData) ?
              <div>
              <DatePicker
                label={i18n.t('formMaintenance.expiration')}
                margin='normal'
                value={expirationDate && new Date(expirationDate)}
                InputProps={{
                  readOnly: !isNewData && !editMode,
                }}
                onChange={date => {
                  if((editMode && !isNewData) || (!editMode && isNewData)) handleExpirationDateChange(date)
                }}
                minDate={new Date(returnFromMaintenanceDate)}
                minDateMessage={'Selecione uma data após a data de Retorno'}
                onError={(err, value) => {
                  err?.toString() === 'Selecione uma data após a data de Retorno' ? setExpirationDateError(true) : setExpirationDateError(false)
                }}
                format="dd/MM/yyyy"
                disabled={editMode && isContractor}
                sx={{marginTop: '10px'}}
                slotProps={{ textField: { variant: 'standard', } }}
              />
            </div>
            :
            <FormLabelWithContent label={i18n.t('formMaintenance.expiration')} value={expirationDate === null ? '-' : moment(expirationDate).format('DD/MM/YYYY')} maintenance={true} />}

                <div style={styles.sectionTitleContainer}>
                  <AttachIcon style={{ color: (!isNewData && !editMode) ? 'lightgrey' : '#000' }} />
                  <Typography style={{ color: (!isNewData && !editMode) ? 'lightgrey' : '#000' }}>{i18n.t('typographyFormActions.file')}</Typography>
                </div>
                <Upload onUpload={handleUpload} disabled={!isNewData && !editMode} />
                {!!uploadedFiles.length && (
                  <FileList files={uploadedFiles} onDelete={handleDeleteDocumentFile} disabled={!editMode && !isNewData} />
                )}
                {uploadSubmitError && <div style={styles.fileError}>{i18n.t('divFormActions.fileError')}</div>}
              </div>
            </>
            {isNewData &&
              <DivSubmitButtons>
                <IconButton onClick={props.history.goBack} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
                <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
              </DivSubmitButtons>}
          </FormStyled>
        </Paper>
      </Container>
      {props.match.params.id !== 'new' && <TimelineMaintenances maintenance={maintenance} maintenanceId={maintenanceId} />}
    </div>
  </>;
}

export default FormHandleMaintenance;
